var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "button",
      attrs: {
        disabled: _vm.disabled,
        type: _vm.type,
        to: _vm.to,
        href: _vm.href,
        target: _vm.target
      },
      on: { click: _vm.onClick }
    },
    [
      _vm.loading
        ? _c("md-progress-spinner", {
            attrs: {
              "md-mode": "indeterminate",
              "md-diameter": 20,
              "md-stroke": 2
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }